import { render } from "./ClassRouter.vue?vue&type=template&id=5be9ab27"
import script from "./ClassRouter.vue?vue&type=script&lang=js"
export * from "./ClassRouter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__